import { Component, Input, OnInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

import { ErrorService } from 'src/app/core/services/error.service';
import { Gender } from 'src/app/core/enums/gender';
import { PairingService } from 'src/app/core/services/pairing.service';
import { Patient } from 'src/app/core/entities/patient.entity';
import { RelationType } from 'src/app/core/enums/relation-type';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
  selector: 'app-unpairing-patient-modal',
  templateUrl: './unpairing-patient-modal.component.html',
  styleUrls: ['./unpairing-patient-modal.component.css'],
})
export class UnpairingPatientModalComponent implements OnInit {
  @Input() public patient: Patient = new Patient();
  public revokationRequest: boolean = false;
  public gender = Gender;
  public anime: any;

  options: AnimationOptions = {
    path: '/assets/animations/dashboard-trash.json',
    loop: false,
    autoplay: false,
  };

  constructor(
    public activeModal: NgbActiveModal,
    private pairingService: PairingService,
    private spinnerService: SpinnerService,
    private errorService: ErrorService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.patient.pairing) {
      this.revokationRequest =
        this.patient.pairing.relationType == RelationType.ACCEPTED;
    }
  }

  animationCreated(animationItem: AnimationItem): void {
    this.anime = animationItem;
  }

  removePairing(): void {
    const obs$ =
      this.patient.pairing.relationType == RelationType.ACCEPTED
        ? this.revokePairing()
        : this.rejectPairing();

    this.spinnerService.show();
    obs$
      .pipe(
        finalize(() => {
          this.spinnerService.hide();
        })
      )
      .subscribe({
        next: (res) => {
          this.toastrService.success(
            this.revokationRequest
              ? $localize`:@@patientsList_modalDeletePairing_toastSuccessMessage:Pairing deleted with success`
              : $localize`:@@patientsList_modalDeclinePairing_toastSuccessMessage:Pairing rejeted with success`
          );
          this.anime.goToAndPlay();
          setTimeout(() => {
            this.activeModal.close(this.patient);
          }, 1000);
        },
        error: (err) => {
          this.errorService.addError(err);
          this.errorService.show();
        },
      });
  }

  rejectPairing(): Observable<any> {
    return this.pairingService.rejectRequest(this.patient.pairing.getId());
  }

  revokePairing(): Observable<any> {
    return this.pairingService.revokeRequest(this.patient.pairing.getId());
  }
}
